export default __webpack_public_path__ + "static/media/IMAGE_4.237d79af.png";